import { render, staticRenderFns } from "./ReplacementList.vue?vue&type=template&id=1c0ccb92&"
import script from "./ReplacementList.vue?vue&type=script&lang=js&"
export * from "./ReplacementList.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0ccb92')) {
      api.createRecord('1c0ccb92', component.options)
    } else {
      api.reload('1c0ccb92', component.options)
    }
    module.hot.accept("./ReplacementList.vue?vue&type=template&id=1c0ccb92&", function () {
      api.rerender('1c0ccb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Requests/ReplacementList.vue"
export default component.exports